import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_CODE_ODOO_LOADING = 'GET_CODE_ODOO_LOADING';
export const GET_CODE_ODOO_SUCCESS = 'GET_CODE_ODOO_SUCCESS';
export const GET_CODE_ODOO_REJECT = 'GET_CODE_ODOO_REJECT';

//* ACTIONS ------------------------------------------------
export const getCodeOdooLoading = () => ({ type: GET_CODE_ODOO_LOADING });
export const getCodeOdooSuccess = (payload) => ({ type: GET_CODE_ODOO_SUCCESS, payload });
export const getCodeOdooReject = (payload) => ({ type: GET_CODE_ODOO_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getCodeOdooRequest = async (params = {}, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/Providers/web/GetProvidersOdoo`, options);
};

